
<body>
    <div class="">
        <div class="login">
            <div class="row">
                <div class="col-md-6 col-lg-6 f-bg">
                    <div class="forgot-left-image" id="forgot-left-image-id">

                    </div>
                </div>
                <div class="col-md-6 col-lg-6">
                    <form class="width100 login-form-container" id="form-forgot" [formGroup]="ForgotPWForm" (ngSubmit)="onSubmit()">
                        <fieldset>
                            <div>
                                <div class="maindiv">
                                    <div class="logobanner">
                                        <img src="{{logopath}}" class="img-fluid"/>
                                    </div>
                                    <div class="welcome-section password-heading">
                                        <h3 class="banner1 login-heading">Password Recovery
                                        </h3>
                                        <p class="password-heading-p">Don't worry ! We will help you recover your
                                            password. Please
                                            enter your email address</p>
                                        <div class="floating-form">
                                            <p class="invalid">{{errorMsg}}</p>
                                            <p class="sucessmsg">{{successMsg}}</p>
                                            <div class="fxg-field input-field-w input-field-sigiup input-gap">
                                                <label for="LoginId" style="display:none;" class="Navuser"
                                                    id="LoginId">User Name</label>
                                                <input type="text"
                                                class="fxg-field__input-text fxg-field__input-text-login fxg-field__input--required sessioncamexclude"
                                                    formControlName="LoginId" id="LoginId" name="LoginId" required="" title="LoginId"
                                                    aria-required="true" data-errmsg="Sorry, this is a required field.">
                                                <span class=" fxg-field__placeholder fxg-field__floating-placeholder"
                                                    tabindex="-1">Email Address</span>
                                                <div>
                                                    <p class="error_msg" *ngIf="displayMessage.LoginId">
                                                        {{displayMessage.LoginId}}</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="margin-top-30  Login_clickinfo">
                                            <button class="btncommon btn-submit-bg" type="submit" id="submit-btn">
                                                Submit
                                            </button>
                                        </div>
                                        <div class="Login_clickinfo">
                                            <div class="text-w text-box-mt-15">
                                                <p class="account account34">Back
                                                    to<a href="login" class="pl-1" id="sign-in"> <span>Sign
                                                            In</span></a>
                                                    <!-- <img class="margin-left-5 float-right cursor-pointer loginimg" src="..\assets\images\login.png"
                                                alt="loginicon"> -->
                                                    <!-- <button class="text-muted text-uppercase text-decoration-none font-weight-bold login2 logintxtbtn loginbtn"
                                                (click)="onSubmit()">Send Password</button> -->
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </fieldset>
                    </form>
                </div>
            </div>
        </div>
    </div>
</body>